import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Souqli Member badge.
 *
 * On a member's own dashboard this says "Member" - they know who they are, and
 * "Verified Member" collided with the separate ID-verification badge sitting
 * next to it. The public-facing wording ("Verified Buyer") lives where it
 * actually does work: on orders and offers, where a seller is deciding whether
 * to trust a stranger.
 */
export function MemberBadge({ className = '', label = 'Member' }: { className?: string; label?: string }) {
  const { data } = useQuery<{ tier: string }>({
    queryKey: ['membership'],
    queryFn: async () => (await api.get('/membership')).data,
    retry: false,
  });
  if (data?.tier !== 'MEMBER') return null;
  return (
    <span className={`pill bg-gold text-ink text-[10px] font-semibold inline-flex items-center gap-1 ${className}`} title="Souqli Member - fee-free orders, early access and buyer perks">
      <svg viewBox="0 0 24 24" className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
      {label}
    </span>
  );
}
